import apiRoutes from '../constants/apiRoutes';
import baseApi from '../services/api';

interface FeedbackPayload {
  type: string;
  text: string;
  attachments?: any[];
}

const feedback = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    submitFeedback: builder.mutation<any, FeedbackPayload>({
      query: (payload) => {
        const formData = new FormData();

        formData.append('type', payload.type);
        formData.append('text', payload.text);

        if (payload.attachments && payload.attachments.length > 0) {
          payload.attachments.forEach((file) => {
            formData.append('attachments', file);
          });
        }
        return {
          url: `${apiRoutes.feedback}`,
          method: 'POST',
          body: formData,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useSubmitFeedbackMutation } = feedback;
